import { usePermissions } from '@nucleus-commerce/admin-kit/permissions';

/**
 * Chat setup is `conversations.manage` (LCW1: the chat settings PATCH needs only that, no longer
 * the store PATCH's `settings.write`): the form tabs, shared shortcuts, departments and bans.
 */
export function useChatSettingsAccess() {
  const { can } = usePermissions();
  return { manage: can('conversations.manage') };
}
